// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-small {
  width: 300px;
  margin-right: 50px
  }
 .title {
  background-color: #6699cc;
  color: #ffffff;
  padding: 10px;
  text-align: center;
  font-size: 100%;
}
.greentext{
  color: green;
}
.center-content {
  margin: auto !important;
  text-align: center;
}
.title h3 {
  color: white !important;
  text-align: left;
  margin-top: auto;
  margin-bottom: auto;
  }
table th {
  background-color: #0b2d71 !important;
  color: white;
  font-weight: bold;
}
th, td {
  border: 1px solid white;
  text-align: center;
  padding: 8px;
}
.bordered-container {
  border: 1px solid #d3d3d3; 
  padding: 20px;
  max-width: 100%;
  margin: 3% 0%;
  border-radius: 1px;
}
table a {
  color: blue;
  cursor: pointer;
  text-decoration: none;
}

table a:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/temporaryredelegation/editredelegation/editredelegation.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ;EACA;CACD;EACC,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB;AACF;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".input-small {\n  width: 300px;\n  margin-right: 50px\n  }\n .title {\n  background-color: #6699cc;\n  color: #ffffff;\n  padding: 10px;\n  text-align: center;\n  font-size: 100%;\n}\n.greentext{\n  color: green;\n}\n.center-content {\n  margin: auto !important;\n  text-align: center;\n}\n.title h3 {\n  color: white !important;\n  text-align: left;\n  margin-top: auto;\n  margin-bottom: auto;\n  }\ntable th {\n  background-color: #0b2d71 !important;\n  color: white;\n  font-weight: bold;\n}\nth, td {\n  border: 1px solid white;\n  text-align: center;\n  padding: 8px;\n}\n.bordered-container {\n  border: 1px solid #d3d3d3; \n  padding: 20px;\n  max-width: 100%;\n  margin: 3% 0%;\n  border-radius: 1px;\n}\ntable a {\n  color: blue;\n  cursor: pointer;\n  text-decoration: none;\n}\n\ntable a:hover {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
